const addItem = (arr, item, index) => {
  arr.splice(index, 0, item);
  return arr;
};

const removeItem = (arr, index) => {
  arr.splice(index, 1);
  return arr;
};

const moveItem = (arr, fromIndex, toIndex) => {
  arr.splice(toIndex, 0, arr.splice(fromIndex, 1)[0]);
  return arr;
};

const replaceItem = (arr, index, items) => {
  arr.splice(index, 1);
  arr.splice(index, 0, ...items);
  return arr;
};

/**
 * Sorts an array of items to put selected items at the beginning while maintaining original order
 *
 * @param {Array} items - Array of items to sort
 * @param {Array} selectedIDs - Array of selected item IDs
 * @returns {Array} Sorted array with selected items at the beginning
 */
const sortBySelected = (arr, selectedIDs) => [...arr].sort((a, b) => {
  const aSelected = selectedIDs.includes(a.id);
  const bSelected = selectedIDs.includes(b.id);
  if (aSelected && !bSelected) return -1;
  if (!aSelected && bSelected) return 1;
  return 0; // Maintain original order for items with same selection status
});

export {
  addItem,
  removeItem,
  moveItem,
  replaceItem,
  sortBySelected,
};
